
import React, { useState } from 'react';
import { styled } from 'styled-components';
import { strings } from '/imports/strings';
import { fileHref } from '/imports/api/files';
import { css } from '/imports/ui/css';
import { PageHeading } from '/imports/ui/PageHeading';
import { PageBody } from '/imports/ui/PageBody';
import { toastOnError } from '/imports/ui/utils';
import { Icon } from '/imports/ui/Icon';
import { queryStringToObject } from '/imports/utils';
import { getSolarBillsForJwtAndAccessCode, SolarBill } from '/imports/api/solarBills';
import { Input } from '/imports/ui/Input';
import { Button } from '/imports/ui/Button';

const ViewSolarBillsPageStyled = styled.div`
  width: 100%;
  height: 100%;
  .access-code-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      height: 9rem;
      width: auto;
      display: block;
      margin: auto;
    }
    .input, .btn {
      display: block;
      margin: auto;
      margin-bottom: 1rem;
      width: 100%;
      input {
        text-align: center;
        width: 100%;
      }
    }
  }
  embed {
    margin-bottom: 2rem;
    border: ${css.inputBorder};
  }
  .accordion-target {
    border: 1px solid ${css.grey3};
    width: 802px;
    padding: 1rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
`;

/**
 * Public page that gates solar bills behind an access code, then renders them as expandable PDF embeds.
 */
export const ViewSolarBillsPage = () => {
  const queryParams = queryStringToObject();
  const jwt = queryParams.jwt || '';
  const [accessCode, setAccessCode] = useState<string>();
  const [bills, setBills] = useState<SolarBill[]>();
  const [expanded, setExpanded] = useState<string[]>([]);
  const getBills = toastOnError(async () => {
    if (!accessCode) return;
    const bills = await getSolarBillsForJwtAndAccessCode.call({ jwt, accessCode });
    setBills(bills);
    setExpanded(bills.map((b) => b._id));
  });
  const toggleExpanded = (billId: string) => {
    if (expanded.includes(billId)) setExpanded(expanded.filter((_id) => _id !== billId));
    else setExpanded([...expanded, billId]);
  };
  if (!accessCode || !bills) {
    return (
      <ViewSolarBillsPageStyled>
        <div className="access-code-wrapper">
          <div>
            <img src="/images/logo_dark.png" alt="Luminia" />
            <Input value={accessCode} onChange={(accessCode) => setAccessCode(accessCode)} placeholder={strings.EnterYourAccessCode()} onEnter={() => getBills()} />
            <Button onClick={() => getBills()}>{strings.Submit()}</Button>
          </div>
        </div>
      </ViewSolarBillsPageStyled>
    );
  }
  return (
    <ViewSolarBillsPageStyled>
      <PageHeading
        left={<h1>{strings.YourSolarEnergyBills()}</h1>}
      />
      <PageBody>
        {
          bills.map((b) => (
            <div key={b._id}>
              <div className="accordion-target" onClick={() => toggleExpanded(b._id)}>
                <Icon icon="chevronRight" />{b.accountNumber} ({b.startDate} - {b.endDate})
              </div>
              <embed
                style={{ display: expanded.includes(b._id) ? 'block' : 'none' }}
                src={fileHref(b.pdf)}
                width="800"
                height="800"
              />
            </div>
          ))
        }
      </PageBody>
    </ViewSolarBillsPageStyled>
  );
};